import { render, staticRenderFns } from "./ModalMostrarMensagem.vue?vue&type=template&id=1f150be0&scoped=true"
import script from "./ModalMostrarMensagem.vue?vue&type=script&lang=js"
export * from "./ModalMostrarMensagem.vue?vue&type=script&lang=js"
import style0 from "./ModalMostrarMensagem.vue?vue&type=style&index=0&id=1f150be0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f150be0",
  null
  
)

export default component.exports